import ConfiguredComponentLoader from './ConfiguredComponentLoader.container';

export default ConfiguredComponentLoader;
